import { createContext, useContext } from 'react';

type VirtualMultiselectWindowContextValue = {
  measureElement: (element: HTMLElement) => void;
};

export const VirtualMultiselectWindowContext =
  createContext<VirtualMultiselectWindowContextValue | null>(null);

export const useVirtualMultiselectWindow = () => {
  const context = useContext(VirtualMultiselectWindowContext);
  if (!context) {
    throw new Error(
      'useVirtualMultiselectWindow must be used within a VirtualMultiselectWindowContextProvider',
    );
  }
  return context;
};
